import { Card, Icon, TextLink, Typography } from 'components';
import { CardErrorBoundaryWithSpinfinity } from 'components/Card/CardErrorBoundaryWithSpinfinity';
import { useLocation } from 'react-router-dom';
import c from 'classnames';

import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import { useEvaluationGroups } from 'views/Results/Insights/hooks/useEvaluationGroups';
import { getEvaluationIconFromColor } from 'views/Results/Insights/EvaluationGroupsSummary/EvaluationGroupsSummary';

import styles from './YourSampleCard.module.scss';

interface SampleItemProps {
  count: number;
  text: string;
  iconColor: string;
  isFirst?: boolean;
}

export const SampleItem = ({
  count,
  text,
  iconColor,
  isFirst = false,
}: SampleItemProps) => {
  const itemClass = c(styles.item, { [styles.borderTop]: !isFirst });
  return (
    <div className={itemClass}>
      <div className={c(styles.iconContainer, styles[iconColor])}>
        <Icon
          name={getEvaluationIconFromColor(iconColor)}
          size='s'
          className={styles[iconColor]}
        />
      </div>
      <Typography variant='heading-m'>
        {count} {text}
      </Typography>
    </div>
  );
};

const YourSampleCardContent = () => {
  const { orangeSubMetrics, redSubMetrics, greySubMetrics, greenSubMetrics } =
    useEvaluationGroups();
  const { pathname } = useLocation();

  return (
    <Card title='Your sample at a glance'>
      <SampleItem
        count={redSubMetrics.length}
        text='Needs support'
        iconColor='red'
        isFirst
      />
      <SampleItem
        count={orangeSubMetrics.length}
        text='Needs improving'
        iconColor='orange'
      />
      <SampleItem
        count={greySubMetrics.length}
        text='Okay results'
        iconColor='grey'
      />
      <SampleItem
        count={greenSubMetrics.length}
        text='Great results'
        iconColor='green'
      />
      <div className={styles.seeAllMetrics}>
        <TextLink
          label='See all metrics'
          size='body-s'
          iconNameRight='chevronForward'
          to={`${pathname}/insights/all-insights?evaluations=red%2Corange%2Cgreen%2Cgrey`}
        />
      </div>
    </Card>
  );
};

export const YourSampleCard = () => {
  return (
    <CardErrorBoundaryWithSpinfinity cardName='YourSampleCard'>
      <YourSampleCardContent />
    </CardErrorBoundaryWithSpinfinity>
  );
};
